module.exports = {"action":["Absorb","Accumulate","Bend","Break Down","Change Phase","Clean","Compress","Concentrate","Condense","Constrain","Cool","Deposit","Destroy","Detect","Dilute","Dry","Evaporate","Expand","Extract","Freeze","Heat","Hold","Join","Melt","Mix","Move","Orient","Produce","Protect","Purify","Remove","Resist","Rotate","Separate","Vibrate"],"object":["Divided Solid","Field","Gas","Liquid","Solid"]}


//////////////////
// WEBPACK FOOTER
// ./src/components/keyword.json
// module id = 676
// module chunks = 0